<template>
    <div style="width: 100%;">
        <div class="lazada-hc-logo"></div>
        <br />
        <img alt="" src="/img/lazada/lazada-cover-study_mobile_revised.png" class="lazada-hc-banner" />
    </div>
</template>
<script>
export default {
    props:['LazadaBannerId']
}
</script>
<style>
    .lazada-hc-logo {
        /* Layout Properties */
        top: 14px;
        left: 36px;
        width: 100%;
        height: 52px;
        /* UI Properties */
        background: transparent url('/img/lazada/logos_desktop.png') center no-repeat padding-box;
        opacity: 1;
    }
    .lazada-hc-banner {
        /* Layout Properties */
        width: 100%;
        /* UI Properties */
        opacity: 1;
    }
</style>